import { render } from "./HomeCenter.vue?vue&type=template&id=31fd99d6&scoped=true"
import script from "./HomeCenter.vue?vue&type=script&lang=js"
export * from "./HomeCenter.vue?vue&type=script&lang=js"

import "./HomeCenter.vue?vue&type=style&index=0&id=31fd99d6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fd99d6"]])

export default __exports__